import type { ReactElement } from 'react';

import BpkText from '@skyscanner-internal/backpack-web/bpk-component-text';

import type { CultureData } from '../Footer';

import STYLES from './CultureText.module.scss';

type CultureTextProps = {
  cultureData: CultureData;
};

const CultureText = ({ cultureData }: CultureTextProps): ReactElement => {
  const { country, currencyData, languageShort } = cultureData;
  // formatted to support right to left
  const currencyString = currencyData ? (
    <>
      <span>{currencyData.symbol}&nbsp;</span>
      <span>{currencyData.currency}</span>
    </>
  ) : null;
  const cultureTextItemSeparator = <span className={STYLES['culture-text__separator']}>·</span>;
  const currencyElement = <span>{currencyString}</span>;

  return (
    <BpkText>
      <span className={STYLES['culture-text']} data-testid="cultureText">
        {country}
        {cultureTextItemSeparator}
        {languageShort}
        {currencyData ? cultureTextItemSeparator : null}
        {currencyData ? currencyElement : null}
      </span>
    </BpkText>
  );
};

export default CultureText;
